export default __webpack_public_path__ + "c85ff3a78c66072f8c6d63217d1a2d54.png";